<template>
  <v-card>
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <v-form @submit.prevent="eps_import_service()">
        <v-card-title>
          {{ $capitalize($tc("model.leads_import_eps_title")) }}
          <v-spacer></v-spacer>
          <v-btn @click="cancel()" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <ValidationProvider name="service_number" rules="required|length:16" v-slot="{ errors }">
          <v-card-text>
            <v-text-field
              name="service_number"
              v-model="service_number"
              :label="
                $capitalize($tc('model.leads_service_number'))
              "
              placeholder="13EPST0002747.01"
              :error-messages="errors"
              :disabled="loading"
            ></v-text-field>
          </v-card-text>
        </ValidationProvider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="cancel()" text>{{ $capitalize($tc("model.leads_cancel_button")) }}</v-btn>
          <v-btn type="submit" color="primary" :disabled="invalid" :loading="loading">
            <v-icon left>mdi-download</v-icon>{{ $capitalize($tc("model.leads_import_button")) }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </ValidationObserver>
  </v-card>
</template>

<script>
import { getLeadAndService } from "@/services/eps";

export default {
  name: "eps-import-lead-form",
  data: () => ({
    eps_import_dialog: false,
    service_number: "",
    loading: false,
  }),
  methods: {
    async eps_import_service() {
      const validation = await this.$refs.form.validate();
      if (validation) {
        this.loading = true;
        try {
          await getLeadAndService(this.service_number);
          await this.resetForm();
          this.$emit("submitted");
        } catch (error) {
          this.$store.commit("sendMessage", {
            text: "Falha ao realizar a acção",
            color: "red",
          });
        } finally {
          this.loading = false;
        }
      }
    },
    async cancel() {
      await this.resetForm();
      this.$emit("cancel");
    },
    resetForm() {
      return new Promise((resolve) => {
        this.service_number = "";
        this.$refs.form.reset();
        resolve();
      });
    },
  },
};
</script>